import type { UIEvent } from 'react';
import { forwardRef, useCallback } from 'react';
import { utilities } from 'core';
import type { LinkWithAnchorProps } from '../@types';
import { LINK_CONST } from '../@types';
import { Link } from './Link.styles';

const LinkWithAnchor = forwardRef(
  ({ children, pathname, ...props }: LinkWithAnchorProps, ref: LinkWithAnchorProps['ref']) => {
    const handleClickAnchor = useCallback((event: UIEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      const { currentTarget } = event;
      const anchorId = currentTarget.getAttribute('href')?.replace(/^#/, '');

      if (anchorId) {
        const target = document.getElementById(anchorId) as HTMLElement;

        utilities.scrollTop(target.offsetTop, {
          animate: true,
          duration: 300,
          includeHeader: true,
        });
      }
    }, []);

    return (
      <Link.Base
        ref={ref}
        data-testid={LINK_CONST.TEST_ID}
        href={pathname}
        onClick={handleClickAnchor}
        {...props}
      >
        {children}
      </Link.Base>
    );
  },
);
LinkWithAnchor.displayName = 'LinkWithAnchor';
export default LinkWithAnchor;
